import { styled } from 'styled-components';

export const TacklingDistributionTeamTile = styled.div`
  svg {
    height: 550px;
    margin: auto;
  }
  padding-bottom: ${({ theme }) => theme.sizing.large};
`;

export const TacklingVizTeamTile = styled.div`
  svg {
    max-height: 470px;
    margin: auto;
  }
`;
